export default {
  GET_LIST: '/manage/userPreload/findList',
  EXPORT_LIST: '/manage/activity/exportList',
  GET_ROLE: '/auth/userRole/findFilter',
  SAVE: '/manage/userPreload/save',
  UPDATE: '/manage/userPreload/update',
  CHECK: '/manage/userPreload/checkAccountExists',
  FIND: '/manage/userPreload/find',
  DELETE: '/manage/userPreload/delete',
  UPDATE_FOR_BATCH: '/manage/userPreload/updateForBatch',
  ANALYSIS_USERS: '/manage/userPreload/resolve/mutiUsers',
  DELETE_ROLES: '/manage/userPreload/removeRoleForBatch',
  ASSIGN_ROLES: '/manage/userPreload/assignRoleForBatch',
  UPDATE_STATUS: '/manage/userPreload/updateStatus',
  GET_REGISTERED_ACCOUNT: '/manage/user/getPreloadRegisteredList',
  FIND_COMPANY_FILTER: '/auth/userPreload/findCompanyFilter',
  FIND_GROUP_FILTER: '/auth/userPreload/findGroupFilter',
  GET_SUFFIX_LIST: '/manage/user/getUserBySuffixAccount',
  getCustomerCompanyData: '/manage/customerCompany/new/customerCompanies',
  getCustomerGroupData: '/manage/customerCompany/customerGroups',
  getCustomerCompanyTableData: '/manage/customerCompany/findList',
  UPDATE_CUSTOMER_COMPANY_STATUS: '/manage/customerCompany/enableOperate',
  DELETE_CUSTOMER_COMPANY: '/manage/customerCompany/delete',
  UPDATE_CUSTOMER_COMPANY: '/manage/customerCompany/update',
  FIND_CUSTOMER_COMPANY: '/manage/customerCompany/find'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/whiteList.js